module.exports = __webpack_public_path__ + "static/gallery07-63df1c61ce3b621a3997857c49eff98b.jpg";